import { useCallback, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Col, Container, Row } from 'reactstrap';
import GoBackButton from '../../../../../components/buttons/GoBackButton';
import { PathsLayouts } from '../../../../../config/routes';
import { PeriodType } from '../../../../../types/PeriodType';
import CurriculumForm from '../CurriculumForm';
import { CurriculumLegend } from '../CurriculumLegend';
import CurriculumStudyPlanInfo from '../CurriculumStudyPlanInfo';
import { CurriculumDegreeActivitiesList } from '../parts/CurriculumDegreeActivities';
import { DegreeAverageOptions } from '../parts/DegreeAverageOptions';

type PropsParams = {
  id: string;
  versionId: string;
};

const CurriculumCreateMention = () => {
  const prefix = 'studyPlans.curriculum';
  const readOnly: boolean = false;

  const history = useHistory();
  const { id: studyPlanId, versionId } = useParams<PropsParams>();

  const [periodType, setPeriodType] = useState<PeriodType>();
  const [studyPlanName, setStudyPlanName] = useState<string>('');
  const [disabledEditButton, setDisabledEditButton] = useState<boolean>(false);

  const goBack = useCallback(() => {
    history.push(
      `${PathsLayouts.academicOffers}/study-plans/record/${studyPlanId}/version/${versionId}/mention/list`,
    );
  }, [history, studyPlanId, versionId]);

  return (
    <Container>
      <Card className="p-3 p-md-4">
        <Row>
          <Col xs={12} md={7}>
            <div className="mb-4">
              <GoBackButton onClick={goBack} />
            </div>
          </Col>
          <Col xs={12} md={5}>
            <CurriculumStudyPlanInfo
              id={studyPlanId}
              versionId={versionId}
              setStudyPlanName={setStudyPlanName}
              setPeriodType={setPeriodType}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12}>
            <CurriculumForm
              studyPlanName={studyPlanName}
              curriculumData={undefined}
              periodType={periodType}
              readOnly={readOnly}
              setDisabledEditButton={setDisabledEditButton}
              isMention
              showSubmitButton={true}
              disabledSubmitButton={disabledEditButton}
              prefix={prefix}
            >
              {({ legend }) => (
                <>
                  <Row>
                    <Col xs={{ size: 12 }}>
                      <CurriculumLegend legend={legend} />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={{ size: 12 }}>
                      <DegreeAverageOptions readOnly={readOnly} />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={{ size: 12 }}>
                      <CurriculumDegreeActivitiesList readOnly={readOnly} />
                    </Col>
                  </Row>
                </>
              )}
            </CurriculumForm>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default CurriculumCreateMention;
